// Module
var code = "<div class=\"c-datatable-moreButtonCell u-sizeFullWidth ui-grid-cell-contents\" title=\"{{row.entity.modified | date :'short' }}\">\n    <div class=\"u-flex u-flexMiddle u-flexSpaced\">\n        <div>{{row.entity.modified | date :\"short\" }}</div>\n    </div>\n</div>\n";
// Exports
module.exports = code;